/**
 * 3.0 작품 맛보기 DTO → 화면 모델.
 * @description 작품 카드는 고른 작품(`selectedWorks`)이 있으면 그것을, 없으면 최신 작품을 몇 개만 쓴다.
 *   각 작품은 앱에서 그 작품을 여는 경로를 갖는다(웹에 작품 상세는 없다).
 */
import { collabV3AppPaths } from "../utils/collabV3AppPaths";
import type { CollabV3SelectedWorkDto, CollabV3WorksDto } from "../dtos";
import type { CollabV3WorkPreview } from "../entities";

/** 최신 작품 — 작품 목록에서 */
export const toCollabV3WorkPreviews = (
  dto: CollabV3WorksDto,
  collabId: number,
): CollabV3WorkPreview[] =>
  dto.data.map((work) => ({
    workId: work.workId,
    imageUrl: work.imageUrls[0]?.trim() || null,
    authorName: work.author.displayName,
    isSelected: work.isSelected,
    appPath: collabV3AppPaths(collabId).work(work.workId),
  }));

/** 고른 작품 — 상세 응답의 `selectedWorks`(그림과 id 만 온다) */
export const toCollabV3SelectedPreviews = (
  works: CollabV3SelectedWorkDto[],
  collabId: number,
): CollabV3WorkPreview[] =>
  works.map((work) => ({
    workId: work.workId,
    imageUrl: work.thumbnailUrl?.trim() || null,
    authorName: null,
    isSelected: true,
    appPath: collabV3AppPaths(collabId).work(work.workId),
  }));
